import { Modal } from 'flowbite-react';
import { ProductInterface } from '@qlevr/shared/interfaces';
import { premiumProductModalTheme } from '../product-premium-toggle/premium-product-modal-theme';

export interface MoreInfoContentProps {
  openModal: boolean;
  setOpenModal: (isOpen: boolean) => void;
  product: ProductInterface;
}

export function TogSwitcherMoreInfoContent({ openModal, setOpenModal, product }: MoreInfoContentProps) {
  const title = product.togMoreInfo?.title;
  const images = product.togMoreInfo?.images;
  const text_after_image = product.togMoreInfo?.text_after_image;
  const text_before_image = product.togMoreInfo?.text_before_image;
  return (
    <Modal
      dismissible
      size="md"
      theme={premiumProductModalTheme}
      show={openModal}
      position={'top-right'}
      onClose={() => setOpenModal(false)}
      className="modal-drawer-overlay bg-black/50 backdrop-blur-sm"
    >
      <Modal.Header>{title}</Modal.Header>
      <Modal.Body>
        <div className="space-y-4 px-4 pb-12">
          {text_before_image && <div className="w-full" dangerouslySetInnerHTML={{ __html: text_before_image! }} />}
          {images?.map((image, key) => <img key={key} src={image.url} loading="lazy" alt={image.altText || ''} />)}
          {text_after_image && <div className="w-full" dangerouslySetInnerHTML={{ __html: text_after_image! }} />}
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default TogSwitcherMoreInfoContent;
